import { render, staticRenderFns } from "./ComfirmDel.vue?vue&type=template&id=62fa005e&scoped=true&"
import script from "./ComfirmDel.vue?vue&type=script&lang=js&"
export * from "./ComfirmDel.vue?vue&type=script&lang=js&"
import style0 from "./ComfirmDel.vue?vue&type=style&index=0&id=62fa005e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa005e",
  null
  
)

export default component.exports